import { useEffect } from 'react'

const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY

let hasAddedScriptToDocument = false
let hasLoadedScript = false

const executeAction = async (action: string) => {
  if (!hasLoadedScript || !hasAddedScriptToDocument) {
    throw new Error('Recaptcha script is not loaded')
  }

  try {
    return await grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, {
      action,
    })
  } catch (e) {
    console.error('An error has occurred while fetching the recaptcha token', e)
    return ''
  }
}

const addRecaptchaScriptToDocument = () => {
  if (!hasAddedScriptToDocument) {
    // Hide recaptcha icon
    const styleNode = document.createElement('style')
    styleNode.innerHTML = '.grecaptcha-badge{visibility:hidden !important;}'
    document.head.appendChild(styleNode)

    // Load recaptcha
    const scriptNode = document.createElement('script')
    scriptNode.setAttribute(
      'src',
      `https://www.google.com/recaptcha/enterprise.js?render=${RECAPTCHA_SITE_KEY}`
    )
    scriptNode.onload = () => {
      grecaptcha.enterprise.ready(async () => {
        hasLoadedScript = true
      })
    }
    document.body.appendChild(scriptNode)
    hasAddedScriptToDocument = true
  }
}

export const useRecaptcha = () => {
  useEffect(() => {
    addRecaptchaScriptToDocument()
  }, [])

  return async (action: string) => {
    return await executeAction(action)
  }
}
